module.exports = __webpack_public_path__ + "static/img/boluo.ca134258.png";